define('clubProperties/clubProperties',[],{
    "ana": {
        "url_cache":"losangeles.angels.mlb.com"
    },
    "ari": {
        "url_cache":"arizona.diamondbacks.mlb.com"
    },
    "atl": {
        "url_cache":"atlanta.braves.mlb.com"
    },
    "bal": {
        "url_cache":"baltimore.orioles.mlb.com"
    },
    "bos": {
        "url_cache":"boston.redsox.mlb.com"
    },
    "chc": {
        "url_cache":"chicago.cubs.mlb.com"
    },
    "cin": {
        "url_cache":"cincinnati.reds.mlb.com"
    },
    "cle": {
        "url_cache":"cleveland.indians.mlb.com"
    },
    "col": {
        "url_cache":"colorado.rockies.mlb.com"
    },
    "cws": {
        "url_cache":"chicago.whitesox.mlb.com"
    },
    "det": {
        "url_cache":"detroit.tigers.mlb.com"
    },
    "hou": {
        "url_cache":"houston.astros.mlb.com"
    },
    "kc": {
        "url_cache":"kansascity.royals.mlb.com"
    },
    "la": {
        "url_cache":"losangeles.dodgers.mlb.com"
    },
    "mia": {
        "url_cache":"miami.marlins.mlb.com"
    },
    "mil": {
        "url_cache":"milwaukee.brewers.mlb.com"
    },
    "min": {
        "url_cache":"minnesota.twins.mlb.com"
    },
    "mlb": {
        "url_cache":"mlb.mlb.com"
    },
    "mlbnetwork": {
    },
    "mlbplayers": {
    },
    "nym": {
        "url_cache":"newyork.mets.mlb.com"
    },
    "nyy": {
        "url_cache":"newyork.yankees.mlb.com"
    },
    "oak": {
        "url_cache":"oakland.athletics.mlb.com"
    },
    "phi": {
        "url_cache":"philadelphia.phillies.mlb.com"
    },
    "pit": {
        "url_cache":"pittsburgh.pirates.mlb.com"
    },
    "sd": {
        "url_cache":"sandiego.padres.mlb.com"
    },
    "sea": {
        "url_cache":"seattle.mariners.mlb.com"
    },
    "sf": {
        "url_cache":"sanfrancisco.giants.mlb.com"
    },
    "stl": {
        "url_cache":"stlouis.cardinals.mlb.com"
    },
    "tb": {
        "url_cache":"tampabay.rays.mlb.com"
    },
    "tex": {
        "url_cache":"texas.rangers.mlb.com"
    },
    "tor": {
        "url_cache":"toronto.bluejays.mlb.com"
    },
    "was": {
        "url_cache":"washington.nationals.mlb.com"
    },
    "wbc": {
    }
});

